import arteHidracolor from "../assets/img/promos/promo-hidracolor-kuul.svg";
import arteHerramientas from "../assets/img/promos/promo-herramientas.svg";
import arteDepilflax from "../assets/img/promos/promo-depilflax.svg";

/**
 * Promociones hardcodeadas (etapa 1 de la V4).
 *
 * Forma de cada promoción:
 *   marca        {string}   Marca o familia sobre la que aplica.
 *   titulo       {string}   La mecánica en corto: "6+1", "96+8"...
 *   descripcion  {string}   Bajada opcional de una línea.
 *   vigencia     {string}   Texto libre que se muestra al pie de la tarjeta.
 *   imagen       {string}   Ruta pública de la foto (ver nota de abajo).
 *   activa       {boolean}  `false` la saca de la home sin borrar el dato.
 *   prioridad    {number}   Orden ascendente. La de prioridad más baja va
 *                           en la tarjeta principal (la grande).
 *
 * Opcionales, para el modal de condiciones:
 *   condiciones  {Array}    [{ subtitulo?, items: [] }]. Sin esto, la tarjeta
 *                           no muestra el botón de "ver condiciones".
 *   nota         {string}   Aclaración al pie del modal.
 *   arte         {string}   Ilustración de respaldo mientras no exista `imagen`.
 *
 * Sobre las imágenes: `imagen` apunta a `static/` (Gatsby publica esa carpeta
 * en la raíz), así que "/assets/promos/x.webp" es "static/assets/promos/x.webp".
 * Mientras el archivo no exista, la tarjeta cae en `arte` y no se rompe el layout.
 *
 * Cuando las promociones salgan del backend, esta lista se reemplaza por la
 * query manteniendo la misma forma y el resto de los componentes no cambia.
 */
export const promotions = [
	{
		marca: "Hidracolor",
		titulo: "6+1",
		descripcion: "En productos seleccionados",
		vigencia: "Desde 01/08/2026",
		imagen: "/assets/promos/hidracolor-6x1.webp",
		activa: true,
		prioridad: 1,
		arte: arteHidracolor,
		condiciones: [
			{
				items: [
					"Sachet Hidraplex: 6+1.",
					"Productos: 6+1, combinables. No participan los shampoo matizador.",
					"Oxidantes de 870 ml: 6+1."
				]
			}
		],
		nota: "Vigencia informada: desde el 1 de agosto de 2026. Consultá siempre las condiciones actualizadas."
	},
	{
		marca: "Küül",
		titulo: "6+1",
		descripcion: "Promoción independiente de la de Hidracolor",
		vigencia: "Desde 01/08/2026",
		imagen: "/assets/promos/kuul-6x1.webp",
		activa: true,
		prioridad: 2,
		arte: arteHidracolor,
		condiciones: [
			{
				items: [
					"Productos: 6+1.",
					"Pomos de 60 g: 60+40 o 120+120; no se superpone con los descuentos habituales."
				]
			}
		],
		nota: "Vigencia informada: desde el 1 de agosto de 2026. Consultá siempre las condiciones actualizadas."
	},
	{
		marca: "Herramientas eléctricas",
		titulo: "6+1",
		descripcion: "Códigos combinables",
		vigencia: "Consultá vigencia",
		imagen: "/assets/promos/herramientas-6x1.webp",
		activa: true,
		prioridad: 3,
		arte: arteHerramientas,
		condiciones: [
			{
				items: [
					"Promoción 6+1.",
					"Se pueden combinar diferentes códigos y se factura sin cargo el artículo de menor valor."
				]
			}
		],
		nota: "La aplicación está sujeta a las condiciones comerciales vigentes de cada cliente."
	},
	{
		marca: "Depilflax",
		titulo: "96+8",
		descripcion: "Roll-on",
		vigencia: "Consultá vigencia",
		imagen: "/assets/promos/depilflax-96x8.webp",
		activa: true,
		prioridad: 4,
		arte: arteDepilflax,
		condiciones: [
			{
				items: [
					"Roll-on: 96+8.",
					"Cera kilo: 48+4 o 96+16.",
					"Papel depilatorio: 6+1 en todas las presentaciones."
				]
			}
		],
		nota: "Consultá disponibilidad y condiciones antes de confirmar el pedido."
	}
];

/**
 * Promociones activas, ordenadas por prioridad ascendente.
 */
export const getActivePromotions = () =>
	promotions
		.filter((promotion) => promotion.activa)
		.sort((a, b) => a.prioridad - b.prioridad);

export default promotions;
